import React from 'react';
import BrandingFooter from '../common/BrandingFooter';
import TeamCell from '../common/TeamCell';
import MatchWidgetShell from '../common/MatchWidgetShell';
import { useWidgetLabels } from '../common/WidgetLabelsContext';

function StatBox({ label, value }) {
  return (
    <div className="sw-meta-tile flex-col items-center text-center !p-3">
      <p className="sw-meta-tile__label">{label}</p>
      <p className="text-xl font-black tabular-nums mt-1">{value ?? '—'}</p>
    </div>
  );
}

export default function PlayerProfile({
  showBranding = false,
  competitionLabel = '',
  playerProfile = null,
}) {
  const t = useWidgetLabels();
  const p = playerProfile;
  return (
    <div>
      <MatchWidgetShell competitionLabel={competitionLabel} subtitle={t('playerProfile')}>
        {p ? (
          <>
            <div className="sw-match-hero sw-match-hero--finished relative">
              <div className="sw-match-hero__glow" aria-hidden />
              <div className="relative z-[1] px-5 py-6 flex flex-col items-center text-center">
                <h2 className="text-2xl font-black">{p.player}</h2>
                <div
                  className="text-sm mt-2 flex items-center justify-center gap-2 flex-wrap"
                  style={{ color: 'var(--sw-muted)' }}
                >
                  <TeamCell row={p} size={22} />
                  {p.position && <span>· {p.position}</span>}
                  {p.rank && <span>· #{p.rank}</span>}
                </div>
              </div>
            </div>
            <div className="p-4 grid grid-cols-3 gap-2">
              <StatBox label={t('goals')} value={p.goals ?? 0} />
              <StatBox label={t('assists')} value={p.assists ?? 0} />
              <StatBox label={t('appearances')} value={p.appearances} />
            </div>
          </>
        ) : (
          <p className="text-center text-xs py-10" style={{ color: 'var(--sw-muted)' }}>
            {t('noData')}
          </p>
        )}
      </MatchWidgetShell>
      {showBranding && <BrandingFooter />}
    </div>
  );
}
